import { cva } from 'class-variance-authority';

import type { VariantProps } from 'class-variance-authority';
import type { FC, HTMLAttributes } from 'react';

import s from './GroupWrapper.module.css';

const variants = cva(s.wrapper, {
  variants: {
    gradient: {
      true: s.gradient,
    },
  },
});

type GroupWrapperProps = HTMLAttributes<HTMLDivElement> & VariantProps<typeof variants>;

const GroupWrapper: FC<GroupWrapperProps> = ({ className, gradient, ...props }) => (
  <div className={variants({ className, gradient })} {...props} />
);

export { GroupWrapper };
